import { FC } from 'react';
import { IRole, ROLES } from '../../model/IRole';

import { icons } from '../../icons/IconSet';
import { ITicketRoleFull } from '../../model/ITicketRole';

const UserRoleInfo: FC<{
  userRole?: IRole[],
  vendorRole?: ITicketRoleFull[],
  agentRole?: ITicketRoleFull[],
  className?: string,
}> = ({
  userRole = [],
  vendorRole = [],
  agentRole = [],
  className = '',
}) => !userRole?.length
      ? null
      : (
        <ul className={`flex flex-col gap-5 ${className}`}>
          {userRole.map(({ role }) => (
            <li key={`role${role}`} className="font-semibold text-[1.1em]">
              {ROLES?.[role] || ''}
              {role === 'ROLE_VENDOR' && vendorRole?.length && (
                <ul className="pl-[.3em] font-normal">
                  {vendorRole.map(({ ticketRole: { id: title }, vendor: { name }, id }) => (
                    <li key={`vendorRole${id}`} className="flex gap-1 align-bottom">
                      {icons('corner-down-right', { width: '20px', stroke: '#999' })} {title} ({name})
                      {/* <span className="text-[.9em]">{parseISOToString(created)}</span> */}
                    </li>
                  ))}
                </ul>
              )}
              {role === 'ROLE_AGENT' && agentRole?.length && (
                <ul className="pl-[.3em] font-normal">
                  {agentRole.map(({ ticketRole: { id: title }, id }) => (
                    <li key={`agentRole${id}`} className="flex gap-1 align-bottom">
                      {icons('corner-down-right', { width: '20px', stroke: '#999' })} {title}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      );

export default UserRoleInfo;
